"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6717],{

/***/ 83935:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var src_uikit__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(82106);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51469);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(48641);
/* harmony import */ var src_utils_gtm__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29590);
/* harmony import */ var src_utils_gtm__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(28173);
/* harmony import */ var _common_Carousel__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(71054);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(56917);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


const _excluded = ["title", "href", "action", "alt", "offers", "target", "numPerView", "w", "bgColor", "listId", "listName", "trackView"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










const HomeOffersList = _ref => {
  let {
    title,
    href,
    action,
    alt,
    offers,
    target,
    numPerView,
    w,
    bgColor,
    listId = 'home_nlt_offers',
    listName = 'Home — Offerte noleggio a lungo termine',
    trackView = true
  } = _ref,
      others = (0,_codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  const isMobile = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .useBreakpointValue */ .Sx)({
    base: true,
    md: false
  });
  const listItems = offers.map((offer, index) => (0,src_utils_gtm__WEBPACK_IMPORTED_MODULE_5__/* .rentOfferToProductItem */ .ck)(offer, {
    index
  }));
  (0,src_utils_gtm__WEBPACK_IMPORTED_MODULE_6__/* .useViewItemList */ .A)({
    items: listItems,
    listId,
    listName,
    enabled: trackView
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Box */ .xu, {
    bgColor: bgColor || 'white',
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Container */ .W2, _objectSpread(_objectSpread({
      as: _chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Box */ .xu,
      maxW: w || '8xl',
      pt: 10
    }, others), {}, {
      id: "offers-list-rent",
      px: "0",
      children: [title && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(src_uikit__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        title: title,
        action: action,
        href: href,
        alt: alt,
        target: target
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_common_Carousel__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        withCustomNavigation: !isMobile,
        breakpoints: {
          320: {
            slidesPerView: 1.3,
            spaceBetween: 18,
            centeredSlides: true
          },
          480: {
            slidesPerView: 2,
            spaceBetween: 30
          },
          640: {
            slidesPerView: numPerView ? Math.ceil(numPerView / 2) : 3,
            spaceBetween: 30
          },
          1280: {
            slidesPerView: numPerView || 4,
            spaceBetween: 30
          }
        },
        withScrollbar: true,
        className: isMobile ? 'has-partial-slide' : null,
        children: offers.map((offer, index) => {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_common_Carousel__WEBPACK_IMPORTED_MODULE_9__/* ["default"].Item */ .Z.Item, {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(___WEBPACK_IMPORTED_MODULE_10__["default"], {
              item: offer,
              index: index,
              listId: listId,
              listName: listName
            })
          }, offer.code);
        })
      })]
    }))
  });
};

/* harmony default export */ __webpack_exports__["default"] = (HomeOffersList);

/***/ }),

/***/ 71054:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export CarouselItem */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62852);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85278);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(53918);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30933);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var swiper_css_scrollbar__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13390);
/* harmony import */ var swiper_css_scrollbar__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(swiper_css_scrollbar__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(swiper_css_navigation__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68770);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(swiper_css_pagination__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var swiper_css_grid__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2416);
/* harmony import */ var swiper_css_grid__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(swiper_css_grid__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(85893);












swiper__WEBPACK_IMPORTED_MODULE_1__/* ["default"].use */ .ZP.use([swiper__WEBPACK_IMPORTED_MODULE_1__/* .Scrollbar */ .LW, swiper__WEBPACK_IMPORTED_MODULE_1__/* .Pagination */ .tl, swiper__WEBPACK_IMPORTED_MODULE_1__/* .Navigation */ .W_, swiper__WEBPACK_IMPORTED_MODULE_1__/* .Grid */ .rj]);
const Wrapper = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_9__["default"].span.withConfig({
  componentId: "sc-1vzw1za-0"
})(["position:relative;display:", ";.swiper-grid-column{height:100%;}"], props => props.withCustomNavigation ? 'block' : 'inline');
/*
  workaround
  @see https://github.com/nolimits4web/swiper/issues/4413
  @see https://github.com/nolimits4web/swiper/issues/4084
*/

const Item = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.Fragment, {
    children: children
  });
};

const CarouselItem = _ref2 => {
  let {
    children
  } = _ref2;
  return /*#__PURE__*/_jsx(SwiperSlide, {
    children: children
  });
};

const Carousel = _ref3 => {
  let {
    children,
    withScrollbar,
    withNavigation,
    withCustomNavigation,
    withPagination,
    slidesPerView,
    spaceBetween,
    className,
    breakpoints,
    grid
  } = _ref3;
  const {
    0: uniqueId,
    1: setUniqueId
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    setUniqueId(`${Math.random()}`.substring(2, 15));
  }, []);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(Wrapper, {
    className: className || '',
    withCustomNavigation: withCustomNavigation,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(swiper_react__WEBPACK_IMPORTED_MODULE_2__/* .Swiper */ .tq, {
      navigation: withCustomNavigation ? {
        nextEl: `.carousel-custom-next--${uniqueId}`,
        prevEl: `.carousel-custom-prev--${uniqueId}`
      } : withNavigation || false,
      pagination: withPagination ? {
        clickable: true
      } : false,
      scrollbar: withScrollbar ? {
        draggable: true,
        hide: false
      } : false,
      slidesPerView: slidesPerView || 'auto',
      spaceBetween: spaceBetween || 1,
      breakpoints: breakpoints,
      grid: grid,
      loopFillGroupWithBlank: true,
      children: [withCustomNavigation && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.Fragment, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("span", {
          className: `carousel-custom-next carousel-custom-next--${uniqueId}`
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("span", {
          className: `carousel-custom-prev carousel-custom-prev--${uniqueId}`
        })]
      }), react__WEBPACK_IMPORTED_MODULE_0__.Children.map(children, child => /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_2__/* .SwiperSlide */ .o5, {
        children: child
      }))]
    })
  });
};

Carousel.Item = Item;
/* harmony default export */ __webpack_exports__["Z"] = (Carousel);

/***/ }),

/***/ 20316:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48641);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




const SimpleLink = _ref => {
  let {
    action,
    href,
    title,
    target
  } = _ref;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Link */ .rU, {
    color: "primaryGreen.800",
    title: title,
    target: target || '_self',
    fontFamily: "Montserrat-Medium, sans-serif",
    fontSize: "1rem",
    letterSpacing: "0.3px",
    lineHeight: "22.8px",
    _hover: {
      textDecoration: 'none'
    },
    href: href,
    children: action
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (SimpleLink);

/***/ }),

/***/ 89149:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48641);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


const _excluded = ["children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





const H3 = _ref => {
  let {
    children
  } = _ref,
      others = (0,_codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xv, _objectSpread(_objectSpread({
    as: "h3",
    marginBottom: "xxl4",
    fontFamily: "Montserrat-SemiBold",
    fontSize: "1.75rem",
    lineHeight: "2.275rem"
  }, others), {}, {
    color: "baseDark",
    children: children
  }));
};

/* harmony default export */ __webpack_exports__["Z"] = (H3);

/***/ }),

/***/ 82106:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53918);
/* harmony import */ var src_uikit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89149);
/* harmony import */ var src_uikit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(20316);
/* harmony import */ var src_styles_styled_components_Texts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2732);
/* harmony import */ var src_icons__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(36717);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51469);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);









const Action = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
  componentId: "sc-1cdvsk2-0"
})(["text-align:center;& svg{display:inline;margin-bottom:-3px;}& a{", "}"], src_styles_styled_components_Texts__WEBPACK_IMPORTED_MODULE_3__/* .TextStyles.interactiveLinksSDark500Sx */ .k.interactiveLinksSDark500Sx);
const ActionFloat = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].span.withConfig({
  componentId: "sc-1cdvsk2-1"
})(["float:right;& svg{display:inline;margin-bottom:-3px;}& a{", "}"], src_styles_styled_components_Texts__WEBPACK_IMPORTED_MODULE_3__/* .TextStyles.interactiveLinksSDark500Sx */ .k.interactiveLinksSDark500Sx);

const SectionTitle = _ref => {
  let {
    title,
    action,
    alt,
    href,
    target,
    icon
  } = _ref;
  const isMobile = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .useBreakpointValue */ .Sx)({
    base: true,
    md: false
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(src_uikit__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
    textAlign: isMobile ? 'center' : 'left',
    marginBottom: "1.8rem",
    children: [title, href && action ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
      children: isMobile ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Action, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_uikit__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
          action: action,
          href: href,
          title: alt,
          target: target || '_blank'
        }), icon || /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_icons__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {})]
      }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(ActionFloat, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_uikit__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
          action: action,
          href: href,
          title: alt,
          target: target || '_blank'
        }), icon || /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_icons__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {})]
      })
    }) : null]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (SectionTitle);

/***/ }),

/***/ 28173:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ useViewItemList; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _events__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99778);
/* harmony import */ var _state__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22988);




/**
 * Emette `view_item_list` quando la lista mostrata cambia davvero.
 *
 * I listing si ri-renderizzano a ogni cambio di filtro o di pagina e l'array
 * `items` è ricostruito ogni volta: la firma sugli id evita di ripetere lo
 * stesso evento a ogni render mantenendo il push su un cambio reale di risultati.
 *
 * L'evento passa da `whenPageReady` perché queste liste arrivano da import
 * dinamici: senza attendere il `page_view` della pagina che le contiene
 * partirebbero con il `page_data` di quella precedente.
 */
function useViewItemList(_ref) {
  let {
    items,
    listId,
    listName,
    enabled = true
  } = _ref;
  const lastSignature = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const queued = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
  const latest = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({
    items,
    listId,
    listName
  });
  latest.current = {
    items,
    listId,
    listName
  };
  const signature = `${listId}|${items.map(item => item.item_id).join(',')}`;
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!enabled) return;
    if (!items.length) return;
    if (lastSignature.current === signature) return;
    lastSignature.current = signature; // Se i risultati cambiano ancora mentre siamo in coda — i filtri del listing
    // che si assestano prima dell'idratazione — non serve una seconda emissione:
    // al flush si legge comunque la lista aggiornata.

    if (queued.current) return;
    queued.current = true;
    (0,_state__WEBPACK_IMPORTED_MODULE_1__/* .whenPageReady */ .lN)(() => {
      queued.current = false;
      (0,_events__WEBPACK_IMPORTED_MODULE_2__/* .pushViewItemList */ .LM)(latest.current);
    }); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [signature, enabled]);
}

/***/ }),

/***/ 55352:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jj": function() { return /* binding */ getWindow; },
/* harmony export */   "Me": function() { return /* binding */ getDocument; }
/* harmony export */ });
/* unused harmony exports extend, ssrDocument, ssrWindow */
/**
 * SSR Window 4.0.2
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2021, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: December 13, 2021
 */

/* eslint-disable no-param-reassign */
function isObject(obj) {
  return obj !== null && typeof obj === 'object' && 'constructor' in obj && obj.constructor === Object;
}

function extend() {
  let target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let src = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  Object.keys(src).forEach(key => {
    if (typeof target[key] === 'undefined') target[key] = src[key];else if (isObject(src[key]) && isObject(target[key]) && Object.keys(src[key]).length > 0) {
      extend(target[key], src[key]);
    }
  });
}

const ssrDocument = {
  body: {},

  addEventListener() {},

  removeEventListener() {},

  activeElement: {
    blur() {},

    nodeName: ''
  },

  querySelector() {
    return null;
  },

  querySelectorAll() {
    return [];
  },

  getElementById() {
    return null;
  },

  createEvent() {
    return {
      initEvent() {}

    };
  },

  createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},

      setAttribute() {},

      getElementsByTagName() {
        return [];
      }

    };
  },

  createElementNS() {
    return {};
  },

  importNode() {
    return null;
  },

  location: {
    hash: '',
    host: '',
    hostname: '',
    href: '',
    origin: '',
    pathname: '',
    protocol: '',
    search: ''
  }
};

function getDocument() {
  const doc = typeof document !== 'undefined' ? document : {};
  extend(doc, ssrDocument);
  return doc;
}

const ssrWindow = {
  document: ssrDocument,
  navigator: {
    userAgent: ''
  },
  location: {
    hash: '',
    host: '',
    hostname: '',
    href: '',
    origin: '',
    pathname: '',
    protocol: '',
    search: ''
  },
  history: {
    replaceState() {},

    pushState() {},

    go() {},

    back() {}

  },
  CustomEvent: function CustomEvent() {
    return this;
  },

  addEventListener() {},

  removeEventListener() {},

  getComputedStyle() {
    return {
      getPropertyValue() {
        return '';
      }

    };
  },

  Image() {},

  Date() {},

  screen: {},

  setTimeout() {},

  clearTimeout() {},

  matchMedia() {
    return {};
  },

  requestAnimationFrame(callback) {
    if (typeof setTimeout === 'undefined') {
      callback();
      return null;
    }

    return setTimeout(callback, 0);
  },

  cancelAnimationFrame(id) {
    if (typeof setTimeout === 'undefined') {
      return;
    }

    clearTimeout(id);
  }

};

function getWindow() {
  const win =  true ? window : 0;
  extend(win, ssrWindow);
  return win;
}



/***/ })

}]);